import { render, staticRenderFns } from "./CierreSesion.vue?vue&type=template&id=20a96b51&scoped=true"
import script from "./CierreSesion.vue?vue&type=script&lang=js"
export * from "./CierreSesion.vue?vue&type=script&lang=js"
import style0 from "./CierreSesion.vue?vue&type=style&index=0&id=20a96b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a96b51",
  null
  
)

export default component.exports